import React from "react";
import PropTypes from "prop-types";
import { Plus, UserX } from "lucide-react";

import { UIEmptyState } from "../../../components/ui";

const TeamListEmptyState = ({
  searchTerm,
  total,
  copy,
  canAdd,
  actionLabel,
  onAction,
}) => {
  const isSearchEmpty = Boolean(String(searchTerm || "").trim()) && total === 0;

  return (
    <UIEmptyState
      classNames={{ root: "team-management__empty" }}
      title={isSearchEmpty ? copy.searchEmptyTitle : copy.emptyTitle}
      description={isSearchEmpty ? undefined : copy.emptyDescription}
      icon={<UserX aria-hidden />}
      actionLabel={isSearchEmpty || !canAdd ? undefined : actionLabel}
      actionIcon={isSearchEmpty || !canAdd ? undefined : <Plus aria-hidden />}
      onAction={isSearchEmpty || !canAdd ? undefined : onAction}
    />
  );
};

TeamListEmptyState.propTypes = {
  searchTerm: PropTypes.string,
  total: PropTypes.number.isRequired,
  copy: PropTypes.shape({
    emptyTitle: PropTypes.string.isRequired,
    emptyDescription: PropTypes.string.isRequired,
    searchEmptyTitle: PropTypes.string.isRequired,
  }).isRequired,
  canAdd: PropTypes.bool,
  actionLabel: PropTypes.string,
  onAction: PropTypes.func,
};

TeamListEmptyState.defaultProps = {
  searchTerm: "",
  canAdd: false,
  actionLabel: undefined,
  onAction: undefined,
};

export default TeamListEmptyState;
